<div class="ui-sticker__wrapper__background"
  ><div class="ui-sticker__clip-path-content-box"
    ><div
      [ngClass]="{
        'ui-sticker__wrapper__background__progress--done': mode === loopModes.DONE,
        'ui-sticker__wrapper__background__progress--expert': mode === loopModes.EXPERT
      }"
      class="ui-sticker__wrapper__background__progress"
      [@.disabled]="!useFillAnimation"
      [@fill]="fillAnimation"
      (@fill.done)="animDone($event)"
      [ngStyle]="fillStyle"
    ></div></div
></div>
<div
  [class.ui-sticker__background__content--achieved]="mode === loopModes.DONE"
  class="ui-sticker__background__content"
>
  <ng-content select="campus-sticker-image"></ng-content>
</div>
